module.exports = __webpack_public_path__ + "static/media/Keah-sm.0df02c89.jpg";